import { getFormAuthorities } from "./authorities"

export const readForm = defineAbility((user) => {
  const authorities = getFormAuthorities(user)
  return authorities.includes("FORM_READ")
})

export const editForm = defineAbility((user) => {
  const authorities = getFormAuthorities(user)
  return authorities.includes("FORM_EDIT")
})

export const createForm = defineAbility((user) => {
  const authorities = getFormAuthorities(user)
  return authorities.includes("FORM_CREATE")
})

export const deleteForm = defineAbility((user) => {
  const authorities = getFormAuthorities(user)
  return authorities.includes("FORM_DELETE")
})
